<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a @click="backButton"><li>Investment</li></a>
      <a @click="insuranceDashbord"
        ><li>&nbsp;>&nbsp;Insurance Dashboard</li></a
      >
      <a @click="insuranceAccounts"><li>&nbsp;>&nbsp;Insurance</li></a>

      <li>&nbsp;>&nbsp;Life Insurance</li>
    </ul>
    <h4 class="welcome-text">Life Insurance</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
          <h4>Enter Details</h4>
          <div
            class="OrBox"
            style="
              text-align: center;
              padding: 0px 0px 10px 0px;
              max-width: 709px;
              font-weight: 700;
              font-size: 20px;
            "
          >
            OR
          </div>
          <v-row>
            <v-col
              xs="12"
              md="6"
              v-for="formAttr in formAttributes"
              :key="formAttr.id"
              v-if="
                formAttr['name'] != 'number_of_money_back_payouts' &&
                formAttr['name'] != 'types_of_payouts' &&
                formAttr['name'] != 'number_of_regular_payouts' &&
                formAttr['name'] != 'payout_start_date' &&
                formAttr['name'] != 'payout_end_date' &&
                formAttr['name'] != 'payout_amount_to_start' &&
                formAttr['name'] != 'payout_amount_changes_each_year'
              "
              class="member_relation_box col"
              :id="formAttr['name'] + 1"
            >
              <label
                class="member-label"
                v-if="formAttr['name'] == 'maturity_value'"
                >{{ isLable }}</label
              >
              <label class="member-label" v-else>{{ formAttr["label"] }}</label>
              <div
                v-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] != 'nominee' &&
                  formAttr['name'] != 'instalment_mode' &&
                  formAttr['name'] != 'premium_due_date' &&
                  formAttr['name'] != 'account_owner' &&
                  formAttr['name'] != 'insured_person' &&
                  formAttr['name'] != 'insurance_company' &&
                  formAttr['name'] != 'policy_name'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :items="
                    formAttr['name'] == 'insurance_company'
                      ? getLifeInsuranceCompany
                      : formAttr['name'] == 'policy_name'
                      ? policyName
                      : formAttr['name'] == 'account_owner'
                      ? account_owner
                      : formAttr['name'] == 'insured_person'
                      ? insured_person
                      : familyMember
                  "
                  item-value="id"
                  item-text="name"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'insurance_company'
                "
              >
                <v-select
                  ref="form_attrs"
                  name="insurance_company"
                  v-model="insurance_company"
                  :items="getLifeInsuranceCompany"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                ></v-select>
              </div>
              <div
                v-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'policy_name'
                "
              >
                <v-select
                  ref="form_attrs"
                  name="policy_name"
                  :items="policyName"
                  v-model="policy_name1"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'insured_person'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :items="insured_person"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'account_owner'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :items="account_owner"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'instalment_mode'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  v-model="instalment_mode"
                  :items="getInstalmentMode"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="changeDateEvent"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' && formAttr['name'] == 'nominee'
                "
              >
                <v-combobox
                  :ref="formAttr['name']"
                  :name="formAttr['name']"
                  v-model="addMoreField"
                  :items="nominee"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                  multiple
                  small-chips
                  solo
                  v-on:input="limiter"
                  deletable-chips
                ></v-combobox>
                <a @click="appendField" class="add-newbox">Add New Nominee</a>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' &&
                  formAttr['name'] == 'policy_name'
                "
              >
                <v-combobox
                  :ref="formAttr['name']"
                  :name="formAttr['name']"
                  :items="policyName"
                  v-model="formAttr['name']"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])
                  "
                  multiple
                  small-chips
                  solo
                  deletable-chips
                  @click:close="limiter"
                ></v-combobox>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'uin_number'
                "
              >
                <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="validateUIN($event)"
                  :value="formAttr['value']"
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'policy_number'
                "
              >
                <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :rules="
                    formAttr['is_required'] == false
                      ? [
                          (v) =>
                            !v ||
                            /^(?=.*[0-9])[a-zA-Z0-9]+$/.test(v) ||
                            'Field must be alphanumeric or numeric',
                        ]
                      : []
                  "
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  :value="formAttr['value']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] != 'policy_number' &&
                  formAttr['name'] != 'surrender_value' &&
                  formAttr['name'] != 'maturity_value' &&
                  formAttr['name'] != 'policy_type'
                "
                :class="
                  formAttr['name'] == 'amount_invested' ||
                  formAttr['name'] == 'current_balance' ||
                  formAttr['name'] == 'maturity_amount'
                    ? 'rupee-icon'
                    : ''
                "
              >
                <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :rules="
                    formAttr['is_required'] == false
                      ? [
                          (v) =>
                            !v ||
                            /^\d{0,8}[.]?\d{1,2}$/.test(v) ||
                            'Field must be numeric',
                        ]
                      : []
                  "
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['name'] == 'maturity_amount'
                      ? maturity_balance_value
                      : formAttr['value']
                  "
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'maturity_value'
                "
              >
                <v-text-field
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :rules="
                    formAttr['is_required'] == false
                      ? [
                          (v) =>
                            !v ||
                            /^\d*\.?\d*$/.test(v) ||
                            'Field must be numeric',
                        ]
                      : []
                  "
                  :placeholder="isLable"
                  :value="formAttr['value']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'surrender_value' &&
                  isShow
                "
              >
                <v-text-field
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :rules="
                    formAttr['is_required'] == false
                      ? [
                          (v) =>
                            !v ||
                            /^\d*\.?\d*$/.test(v) ||
                            'Field must be numeric',
                        ]
                      : []
                  "
                  :placeholder="formAttr['place_holder']"
                  :value="formAttr['value']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'policy_type'
                "
              >
                <v-text-field
                  :readonly="formAttr['name'] == 'policy_type' ? true : false"
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  :value="
                    formAttr['name'] == 'policy_type'
                      ? policy_type
                      : formAttr['value']
                  "
                ></v-text-field>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'date' &&
                  formAttr['name'] == 'surrender_value_as_on' &&
                  isShow
                "
                class="dob-box"
              >
                <Datepicker
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  format="dd MMM, yyyy"
                  :placeholder="formAttr['place_holder']"
                  :disabledDates="disabledDates"
                  :value="formAttr['value']"
                ></Datepicker>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'date' &&
                  formAttr['name'] == 'policy_start_date'
                "
                class="dob-box"
              >
                <Datepicker
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  format="dd MMM, yyyy"
                  :placeholder="formAttr['place_holder']"
                  :disabledDates="disabledDates"
                  :value="formAttr['value']"
                ></Datepicker>
              </div>
              <div
                v-else-if="
                  formAttr['name'] == 'premium_due_date'
                "
                class="dob-box duedate"
              >
                <!-- <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM"
                    :placeholder="formAttr['place_holder']"
                    :disabledDates="formAttr['name'] == 'policy_maturity_date' ? disabledDatesforMaturity : {}"
                    :value="formAttr['value'][0]"
                  ></Datepicker> -->
                <v-row>
                  <v-col v-if="instalment_mode != 4">
                    <v-select
                      v-model="month"
                      :placeholder="'Months'"
                      :items="months"
                      @change="changeDateEvent"
                    >
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="day"
                      :placeholder="'Days'"
                      :items="days"
                      @change="changeDateEvent"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div class="foramated-output">
                  <span v-for="val in dates">
                    <span>{{ val }}</span>
                  </span>
                </div>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'date' &&
                  formAttr['name'] != 'surrender_value_as_on' &&
                  formAttr['name'] != 'policy_start_date'
                "
                class="dob-box"
              >
                <Datepicker
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  format="dd MMM, yyyy"
                  :placeholder="formAttr['place_holder']"
                  :disabledDates="
                    formAttr['name'] == 'policy_maturity_date'
                      ? disabledDatesforMaturity
                      : {}
                  "
                  :value="formAttr['value']"
                ></Datepicker>
              </div>
            </v-col>

            <v-col
              xs="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Money Back'"
            >
              <label class="member-label">NO. OF MONEY BACK PAYOUTS</label>
              <div>
                <v-text-field
                  name="number_of_money_back_payouts"
                  ref="form_attrs"
                  type="number"
                  v-model="number_of_money_back_payouts"
                  placeholder="Enter Number of Money Back Payouts"
                  :value="formAttr['value']"
                ></v-text-field>
                <a @click="addGrants" class="add-newbox"
                  >Add Money Back Payouts</a
                >
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>Type of Payout</label>
              <div>
                <v-select
                  ref="form_attrs"
                  name="types_of_payouts"
                  v-model="types_of_payouts"
                  :items="getTypesOfPayouts"
                  item-value="id"
                  item-text="name"
                  placeholder="Choose from dropdown"
                ></v-select>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>NUMBER OF REGULAR PAYOUTS</label>
              <div>
                <v-text-field
                  name="number_of_regular_payouts"
                  ref="form_attrs"
                  v-model="number_of_regular_payouts"
                  type="number"
                  placeholder="Enter Number of Regular Payouts"
                  @change="addRegularPayouts"
                  :value="formAttr['value']"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>PAYOUT START DATE</label>
              <div class="dob-box">
                <Datepicker
                  name="payout_start_date"
                  ref="payout_start_date"
                  v-model="payout_start_date"
                  format="dd MMM, yyyy"
                  placeholder="Start Date"
                  :value="formAttr['value']"
                  @input="addRegularPayouts"
                ></Datepicker>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>PAYOUT END DATE</label>
              <div class="dob-box">
                <Datepicker
                  name="payout_end_date"
                  ref="payout_end_date"
                  v-model="payout_end_date"
                  format="dd MMM, yyyy"
                  placeholder="End Date"
                  :value="formAttr['value']"
                ></Datepicker>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>PAYOUT AMOUNT TO START </label>
              <div class="rupee-icon">
                <v-text-field
                  name="payout_amount_to_start"
                  ref="form_attrs"
                  v-model="payout_amount_to_start"
                  type="number"
                  placeholder="Enter Payout Amount To Start"
                  @input="amountChangesEachYear"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="member_relation_box col"
              v-if="policy_type == 'Income' || policy_type == 'Regular Income'"
            >
              <label>PAYOUT AMOUNT CHANGES EACH YEAR</label>
              <div>
                <v-select
                  ref="form_attrs"
                  name="payout_amount_changes_each_year"
                  v-model="payout_amount_changes_each_year"
                  :items="getInsuranceType"
                  item-value="id"
                  item-text="name"
                  placeholder="Choose from dropdown"
                  @change="amountChangesEachYear"
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="
              regular_dialog &&
              (policy_type == 'Income' || policy_type == 'Regular Income')
            "
          >
            <template v-for="(regularAmount, n) in setRegularAmount">
              <v-col cols="6">
                <label>Payout Date</label>
                <div>
                  <p>{{ payoutDates(n) }}</p>
                </div>
              </v-col>
              <v-col cols="6">
                <label>Payout Amount</label>
                <div>
                  <v-text-field
                    :id="`payout_amount.${n}`"
                    :name="`payout_amount.${n}`"
                    ref="form_attrs"
                    type="number"
                    placeholder="Enter payout amount"
                    :value="regularAmount.amount"
                    :readonly="
                      payout_amount_changes_each_year == 0 ? true : false
                    "
                  ></v-text-field>
                </div>
              </v-col>
            </template>
          </v-row>
          <v-row class="mt-4" v-for="input in payout_details">
            <v-col
              xs="12"
              md="12"
              class="member_relation_box col esop-addform-box"
            >
              <v-card class="boxs">
                <div class="close-icon">
                  <!-- <v-img
                    max-height="20"
                    max-width="20"
                    src="../../../../assets/images/delete.png"
                  
                  ></v-img> -->
                </div>
                <v-row class="esop-addform-box-detail">
                  <v-col xs="6" md="6">
                    <label class="member-label">Payout Date</label>
                    <div class="dob-box">
                      <Datepicker
                        v-model="input.payout_date"
                        format="dd MMM, yyyy"
                        :value="payout_date"
                      ></Datepicker>
                    </div>
                  </v-col>
                  <v-col xs="6" md="6">
                    <label class="member-label">Money Back Amount</label>
                    <div class="rupee-icon">
                      <v-text-field
                        v-model="input.money_back_ammount"
                        :value="money_back_ammount"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <span
            v-bind:class="{ 'error-messagebox-login': isAddClassServerError }"
            id="server_side_error"
            >{{ serverError }}</span
          >
          <v-row class="buttonbox">
            <v-btn class="blue-border-btn" @click="insuranceAccounts">
              Cancel
            </v-btn>
            <v-btn class="blue-btn" @click="submit" :disabled="!isFormValid">
              Save
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric,
  alpha,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import JwtService from "../../.././common/jwt.service";
import {
  UPDATE_INSURANCE_FORM,
  EDIT_INSURANCE_FORM,
  GET_INSURANCE_FORM_DETAIL,
  GET_POLICY_NAME_DATA,
} from "../../../../store/actions.type";
import ApiService from "../../../../api/api.service";
import { isEmpty } from "lodash";
export default {
  components: {
    Datepicker,
  },
  mixins: [validationMixin],
  validations: {},
  data: function () {
    return {
      days: [
        { text: "01", value: "01" },
        { text: "02", value: "02" },
        { text: "03", value: "03" },
        { text: "04", value: "04" },
        { text: "05", value: "05" },
        { text: "06", value: "06" },
        { text: "07", value: "07" },
        { text: "08", value: "08" },
        { text: "09", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ],
      day: "",
      months: [
        { text: "Jan", value: "Jan" },
        { text: "Feb", value: "Feb" },
        { text: "Mar", value: "Mar" },
        { text: "Apr", value: "Apr" },
        { text: "May", value: "May" },
        { text: "Jun", value: "Jun" },
        { text: "Jul", value: "Jul" },
        { text: "Aug", value: "Aug" },
        { text: "Sep", value: "Sep" },
        { text: "Oct", value: "Oct" },
        { text: "Nov", value: "Nov" },
        { text: "Dec", value: "Dec" },
      ],
      month: "",
      insurance_company: null,
      policy_name: null,
      policy_name1: null,
      valid: true,
      instalment_mode: "",
      regular_payouts: "",
      payout_amount: "",
      changePayoutAmounts: "",
      isShow: true,
      isLable: "MATURITY VALUE",
      submitted: false,
      activePicker: null,
      types_of_payouts: "",
      payout_amount_changes_each_year: "",
      payout_end_date: "",
      payout_start_date: "",
      number_of_regular_payouts: "",
      payout_amount_to_start: "",
      menu: false,
      isFormValid: true,
      disabledDates: {
        from: new Date(),
      },
      serverError: "",
      isAddClassServerError: false,
      formAttributes: "",
      nominee: [],
      formAttr: "",
      other_form_field: [],
      getLifeInsuranceCompany: [],
      additionalpolicy: [],
      policyName: [],
      familyMember: [],
      other_nominee: [],
      policy_type: "",
      curr_balance_date: "",
      account_type: "",
      bank_name: "",
      account_owne: "",
      addMoreField: [],
      nomineeMembers: [],
      form_id: "",
      dates: [],
      account_owner: [],
      explode: "",
      current_balance_value: "",
      maturity_balance_value: "",
      joint_account_owner: [],
      base_policy_premium: "",
      add_on_n_premium: [],
      total_premium: "",
      base_policy_sum_assured: "",
      add_on_n_sum_assured: [],
      getInstalmentMode: [],
      insured_person: [],
      insured_member: [],
      currentDate: new Date().setDate(new Date().getDate()),
      allow_nominee: 1,
      addOnPolicyName: [],
      selectedAddOnPolicyName: [],
      selectedInsuredMember: [],
      disabledDatesforMaturity: {
        to: new Date(),
      },
      addMoreFieldPolicy: [],
      payout_details: [],
      payout_date: "",
      money_back_ammount: "",
      payoutDate: "",
      getTypesOfPayouts: [],
      getInsuranceType: [],
      regular_payout_details: [],
      number_of_money_back_payouts: 0,
      moneyBackAmount: "",
      selected_regular_payouts: [],
      dialog: false,
      regular_dialog: false,
      setRegularAmount: [],
    };
  },
  created() {
    Fire.$on("loadData", () => {
      this.getEditFormDetail();
    });
  },
  mounted() {
    if (this.$store.getters.getUserDetails.user_name) this.getEditFormDetail();
  },
  watch: {
    formAttributes(newValue, oldValue) {
      newValue.forEach((formAttr) => {
        if (formAttr.name == "insurance_company") {
          this.insurance_company = parseInt(formAttr.value);
        } else if (formAttr.name == "policy_type") {
          this.policy_type = formAttr.value;
        } else if (formAttr.name == "policy_name") {
          this.policy_name1 = parseInt(formAttr.value);
        } else if (formAttr.name == "payout_start_date") {
          this.payout_start_date = formAttr.value;
        } else if (formAttr.name == "payout_end_date") {
          this.payout_end_date = formAttr.value;
        } else if (formAttr.name == "payout_amount_to_start") {
          this.payout_amount_to_start = formAttr.value;
        } else if (formAttr.name == "payout_amount_changes_each_year") {
          this.payout_amount_changes_each_year = parseInt(formAttr.value);
        } else if (formAttr.name == "types_of_payouts") {
          this.types_of_payouts = parseInt(formAttr.value);
        }
      });
    },
  },
  methods: {
    changeDateEvent() {
      this.dates = [];
      let mm = this.month;
      let date = mm + "-" + this.day;
      if (this.day) {
        let currentDate = moment(date).format("DD MMM");
        if (this.instalment_mode == 1) {
          this.dates.push(currentDate);
        } else if (this.instalment_mode == 2) {
          let futureMonth = moment(currentDate).add(6, "M").format("DD MMM");
          this.dates.push(currentDate);
          this.dates.push(futureMonth);
        } else if (this.instalment_mode == 3) {
          let futureMonth1 = moment(currentDate).add(3, "M").format("DD MMM");
          this.dates.push(currentDate);
          this.dates.push(futureMonth1);
          let futureMonth2 = moment(currentDate).add(6, "M").format("DD MMM");
          this.dates.push(futureMonth2);
          let futureMonth3 = moment(currentDate).add(9, "M").format("DD MMM");
          this.dates.push(futureMonth3);
        } else if (this.instalment_mode == 4) {
          this.dates.push(this.day);
        }
      }
    },
    changeTextFieldEvent(e) {
      this.isFormValid = this.$refs.form.validate();
    },
    validateUIN(event) {
      this.isFormValid = this.$refs.form.validate();
      let actualstgLength = event.length;
      if (actualstgLength >= 10) {
        let uin_no = event;
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        ApiService.setHeader();
        ApiService.post("get-insurance-policy-name", {
          aws_cognito_id: cognito_idp,
          uin_number: uin_no,
        }).then((response) => {
          if (response.data.data.insurance_company.length > 0) {
            let insuranceId = response.data.data.insurance_company[0].id;
            let policyId = response.data.data.policy_name[0].id;
            this.getLifeInsuranceCompany.forEach((data) => {
              if (data.id == insuranceId) {
                this.insurance_company = parseInt(data.id);
                let company_id = data.id;
                this.$store
                  .dispatch(GET_POLICY_NAME_DATA, {
                    data: {
                      insurance_company_id: company_id,
                      aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
                    },
                    api: "get-insurance-policy-name",
                  })
                  .then(() => {
                    this.policyName = [];
                    this.addOnPolicyName = [];
                    this.$store.getters.getPolicyNameData.data.policy_name.forEach(
                      (policy) => {
                        this.policyName.push({
                          id: policy.id,
                          name: policy.policy_name,
                          policy_type: policy.policy_type,
                        });
                      }
                    );
                    this.policyName.forEach((policy) => {
                      if (policy.id == policyId) {
                        this.policy_name1 = parseInt(policy.id);
                        this.policy_type = policy.policy_type;
                      }
                    });
                  })
                  .catch(() => {});
              }
            });
          } else {
            this.insurance_company = [];
            this.policy_name1 = [];
            this.policy_type = "";
            this.policyName = [];
            this.addOnPolicyName = [];
            this.selectedAddOnPolicyName = [];
          }
        });
      }
    },
    amountChangesEachYear() {
      if (this.payout_amount_changes_each_year == 0) {
        this.setRegularAmount.forEach((data) => {
          data.amount = this.payout_amount_to_start;
        });
        return this.setRegularAmount;
      } else {
        this.setRegularAmount.forEach((data) => {
          data.amount = "";
        });
        return this.setRegularAmount;
      }
    },
    payoutDates(index) {
      let date = this.payout_start_date ? this.payout_start_date : new Date();
      if (this.types_of_payouts == 2) {
        return moment(String(date)).add(index, "year").format("DD MMM, yyyy");
      } else if (this.types_of_payouts == 3) {
        return moment(String(date))
          .add(index * 6, "month")
          .format("DD MMM, yyyy");
      } else if (this.types_of_payouts == 4) {
        return moment(String(date))
          .add(index * 3, "month")
          .format("DD MMM, yyyy");
      }
       else if(this.types_of_payouts == 5)
      {
        return moment(String(this.payout_start_date))
        .add(index/12, "year")
        .format("DD MMM, yyyy");
      }
      // return moment(String(date)).add(index, "year").format("DD MMM, yyyy");
    },
    payoutAmounts(index) {
      return this.payout_start_date;
    },
    limiter(e) {
      if (e.length + this.other_form_field.length > 3) {
        swal
          .fire({
            title: "Nominee",
            text: "You can add maximum 3 nominees.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            confirmButtonText: "OK",
          })
          .then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
            }
          });
      }
    },
    validate() {
      this.$refs.form.validate();
    },
    addRegularPayouts() {
      console.log('qwerty');
      this.setRegularAmount = [];
      let enddate = '';
      for (var i = 0; i < this.number_of_regular_payouts; i++) {
        enddate = moment(String(this.payoutDates(i))).format("YYYY-MM-DD")
        this.setRegularAmount.push({
          date: enddate,
          amount: this.payout_amount_to_start,
        });
      }
      this.payout_end_date = enddate;
    },
    addGrants() {
      this.payout_details = [];

      for (let i = 0; i < this.number_of_money_back_payouts; i++) {
        let getFormData = document.querySelector("#saving_account");
        if (getFormData.number_of_money_back_payouts.value) {
          if (getFormData.number_of_money_back_payouts.value < 6) {
            this.payout_details.push({
              payout_date: "",
              money_back_ammount: "",
            });
          } else {
            swal
              .fire({
                title: "",
                text: "You can add maximum 5 grants.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  return;
                }
              });
          }
        }
      }
    },
    closeGrantDialog() {
      this.grantObj = {};
      this.moneyBackAmount = "";
      this.payoutDate = "";
      this.dialog = false;
    },
    removeGrantDetail(grantnumber) {
      let i = 0;
      this.payout_details = this.payout_details.filter(
        (item) => item.grantnumber != grantnumber
      );
      this.payout_details.forEach((data) => {
        data.grantnumber = ++i;
      });
    },
    backButton() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title:
                "Your data will be cleared. Are you sure you want to close this?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "Investment" }).catch(() => {});
              }
            })
        : this.$router.push({ name: "Investment" }).catch(() => {});
    },
    insuranceAccounts() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title:
                "Your data will be cleared. Are you sure you want to close this?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router
                  .push({ name: "insurance-dashboard" })
                  .catch(() => {});
              }
            })
        : this.$router.push({ name: "insurance-dashboard" }).catch(() => {});
    },

    submit(e) {
      this.checkFormData = [];
      this.isFormValid = this.$refs.form.validate();
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      if (this.checkFormData.length > 0) {
        this.submitted = true;
        this.$loading(true);
        let jsonObject = [];
        let nominee = [];
        let i = 0;
        const regex = new RegExp("payout_amount.");
        for (const [key, value] of formData.entries()) {
          if (key == "nominee" && value != "") {
            value.split(",").forEach((data) => {
              nominee.push(data);
            });
          } else if (Number.isInteger(parseInt(key)) == true) {
            nominee.push(value);
          } else if (
            key == "policy_start_date" ||
            key == "policy_maturity_date" ||
            key == "premium_due_date" ||
            key == "last_premium_due_date" ||
            key == "surrender_value_as_on" ||
            key == "payout_start_date" ||
            key == "payout_end_date"
          ) {
            if (value == "") {
              jsonObject.push({ key: key, values: value });
            } else {
              jsonObject.push({
                key: key,
                values: moment(String(value)).format("YYYY-MM-DD"),
              });
            }
          } else if (
            key == "payout_amount_to_start" ||
            key == "types_of_payouts" ||
            key == "payout_amount_changes_each_year"
          ) {
            jsonObject.push({ key: key, values: value });
          } else if (key == "number_of_money_back_payouts") {
            let payout_details = [];
            this.payout_details.forEach((payout_detail) => {
              payout_details.push({
                payout_date: moment(String(payout_detail.payout_date)).format(
                  "YYYY-MM-DD"
                ),
                money_back_ammount: payout_detail.money_back_ammount,
              });
            });
            jsonObject.push({ key: key, values: payout_details });
          } else if (regex.test(key)) {
          } else {
            if (
              key == "insurance_company" ||
              key == "policy_name" ||
              key == "account_owner" ||
              key == "insured_person" ||
              key == "instalment_mode" ||
              key == "types_of_payouts" ||
              key == "number_of_money_back_payouts"
            ) {
              jsonObject.push({ key: key, values: parseInt(value) });
            } else if (key != "nominee") {
              jsonObject.push({ key: key, values: value });
            }
          }
          i++;
        }
        // let mm = this.month;
        // jsonObject.push({
        //   key: "premium_due_date_array",
        //   values: this.dates,
        // });
        if (this.instalment_mode == 4) {
          jsonObject.push({
            key: "premium_due_date",
            values: this.day,
          });
        } else {
          jsonObject.push({
            key: "premium_due_date",
            values:this.dates,
          });
        }
        if (
          this.number_of_regular_payouts &&
          (this.policy_type == "Income" || this.policy_type == "Regular Income")
        ) {
          let payoutAmountsArr = [];
          for (let i = 0; i < parseInt(this.number_of_regular_payouts); i++) {
            let val = document.getElementById("payout_amount." + i).value;
            payoutAmountsArr.push({
              date: moment(String(this.payoutDates(i))).format("YYYY-MM-DD"),
              amount: val,
            });
          }
          const index = jsonObject.findIndex((object) => {
            if (object) {
              return object.key === "number_of_regular_payouts";
            }
          });
          jsonObject[index].values = payoutAmountsArr;
        }

        let dynamicFields = [
          { key: "number_of_money_back_payouts", values: "" },
          { key: "number_of_regular_payouts", values: "" },
          { key: "payout_start_date", values: "" },
          { key: "payout_end_date", values: "" },
          { key: "payout_amount_to_start", values: "" },
          { key: "types_of_payouts", values: "" },
          { key: "payout_amount_changes_each_year", values: "" },
        ];

        dynamicFields.forEach((element, index) => {
          let result = jsonObject.some((e) => e.key == element.key);
          if (!result) jsonObject.push(element);
        });

        let nomineeArr = { key: "nominee", values: nominee };
        jsonObject.push(nomineeArr);
        let collected_data = { collected_data: jsonObject };
        // console.log(JSON.stringify(collected_data))
        // return;
        this.$loading(false);
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        this.$store
          .dispatch(UPDATE_INSURANCE_FORM, {
            data: {
              aws_cognito_id: cognito_idp,
              form_id: atob(this.$route.params.id),
              account_owner: getFormData.insured_person.value,
              form_detail: JSON.stringify(collected_data),
            },
            api: "update-insurance-form-details",
          })
          .then(() => {
            this.savingAccountList();
            this.$loading(false);
            Toast.fire({
              icon: "success",
              title: "Data updated successfully",
            });
            this.$router
              .push({ name: "insurance-dashboard", params: { tab: "tab-1" } })
              .catch(() => {});
          })
          .catch(() => {
            this.$loading(false);
          });
      } else {
        return;
      }
    },
    setMasterData: function (attr_type, val) {
      if (attr_type == "insurance_company") {
        let company_id = val;
        this.$store
          .dispatch(GET_POLICY_NAME_DATA, {
            data: {
              insurance_company_id: company_id,
              aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
            },
            api: "get-insurance-policy-name",
          })
          .then(() => {
            this.policyName = [];
            this.policy_type = "";
            this.$store.getters.getPolicyNameData.data.policy_name.forEach(
              (policy) => {
                this.policyName.push({
                  id: policy.id,
                  name: policy.policy_name,
                  policy_type: policy.policy_type,
                });
              }
            );
          })
          .catch(() => {});
      } else if (attr_type == "policy_name") {
        this.policyName.forEach((policy) => {
          if (policy.id == val) {
            this.policy_type = policy.policy_type;
            if (
              this.policy_type == "ULIP - Investment" ||
              this.policy_type == "ULIP - Health" ||
              this.policy_type == "ULIP - Gratuity" ||
              this.policy_type == "ULIP - Pension" ||
              this.policy_type == "ULIP - Annuity"
            ) {
              this.isShow = false;
              this.isLable = "Fund Value";
              document.getElementById("surrender_value_as_on1").style.display =
                "none";
              document.getElementById("surrender_value1").style.display =
                "none";
            } else {
              this.isShow = true;
              document.getElementById("surrender_value_as_on1").style.display =
                "block";
              document.getElementById("surrender_value1").style.display =
                "block";
            }
          }
        });
      }

      // else if (attr_type == 'account_owner') {
      //   let masterDataArr = this.$store.getters.getEditInsuranceForm.data.master_data;
      //   let i = 0;
      //   this.nominee = [];
      //   this.account_owner = [];
      //   this.insured_person = [];
      //   masterDataArr['1']['FamilyMember'].forEach(
      //     familyMember => {
      //       if (parseInt(val) != parseInt(familyMember['id'])) {
      //           this.nominee.push(familyMember.name);
      //           this.account_owner.push({'id':familyMember.id, 'name':familyMember.name});
      //           this.insured_person.push({'id':familyMember.id, 'name':familyMember.name});
      //       }
      //       i++;
      //   });
      // }
      // else if (attr_type == 'insured_person') {
      //   let masterDataArr = this.$store.getters.getEditInsuranceForm.data.master_data;
      //   let i = 0;
      //   this.insured_person = [];
      //   masterDataArr['1']['FamilyMember'].forEach(
      //     familyMember => {
      //       if (parseInt(val) != parseInt(familyMember['id'])) {
      //           this.insured_person.push({'id':familyMember.id, 'name':familyMember.name});
      //       }
      //       i++;
      //   });
      //  }
    },
    appendField() {
      swal
        .fire({
          input: "text",
          inputPlaceholder: "Enter Nominee",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: `Save`,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((result) => {
          if (result.value) {
            let letters = /^[A-Za-z]+$/;
            if (result.value.length > 30) {
              swal
                .fire({
                  title: "Nominee",
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: "warning",
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "OK",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                });
            } else if (result.value.match(letters)) {
              this.nominee.push(result.value);
              this.addMoreField.push(result.value);
            } else {
              swal
                .fire({
                  title: "Nominee",
                  text: "Please enter valid name.",
                  icon: "warning",
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "OK",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                });
            }
          }
          if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
        });

      if (this.addMoreField.length >= 3) {
        swal
          .fire({
            title: "Nominee",
            text: "You can add maximum 3 nominees.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            confirmButtonText: "OK",
          })
          .then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
            }
          });
      }
    },
    appendFieldOnNominee(attr_type, val) {
      this.nominee.push(val);
      this.addMoreField.push(val);
      this.other_form_field.splice(attr_type, 1);
    },
    insuranceDashbord() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title:
                "Your data will be cleared. Are you sure you want to close this?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router
                  .push({ name: "insurance-dashboard" })
                  .catch(() => {});
              }
            })
        : this.$router.push({ name: "insurance-dashboard" }).catch(() => {});
    },

    savingAccountList() {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      this.$store
        .dispatch(GET_INSURANCE_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id: selected_value,
          },
          api: "get-insurance-form-details",
        })
        .then(() => {
          Fire.$emit("insuranceGraphData");
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
    },
    getEditFormDetail() {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      this.$store
        .dispatch(EDIT_INSURANCE_FORM, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            form_type: 5,
            form_id: parseInt(atob(this.$route.params.id)),
          },
          api: "get-insurance-edit-form-details",
        })
        .then(() => {
          this.allow_nominee =
            this.$store.getters.getEditInsuranceForm.allow_nominee;
          this.form_id = this.$store.getters.getEditInsuranceForm.data.form_id;
          this.formAttributes =
            this.$store.getters.getEditInsuranceForm.data.form_attributes.fields;
          // console.log("*********************",this.formAttributes);
          this.$store.getters.getEditInsuranceForm.data.nominee_options.forEach(
            (nomineeOptions) => {
              this.addMoreField.push(nomineeOptions);
            }
          );

          let masterDataArr =
            this.$store.getters.getEditInsuranceForm.data.master_data;
          masterDataArr.forEach((element) => {
            if (element.getLifeInsuranceCompany) {
              element.getLifeInsuranceCompany.forEach(
                (dataLifeInsuranceCompany) => {
                  this.getLifeInsuranceCompany.push({
                    id: dataLifeInsuranceCompany.id,
                    name: dataLifeInsuranceCompany.name,
                  });
                }
              );
            }
            if (element.policyName) {
              element.policyName.forEach((dataPolicyName) => {
                this.policyName.push({
                  id: dataPolicyName.id,
                  name: dataPolicyName.policy_name,
                  policy_type: dataPolicyName.policy_type,
                });
              });
            }
            if (element.instalmentMode) {
              element.instalmentMode.forEach((dataInstalmentMode) => {
                this.getInstalmentMode.push({
                  id: dataInstalmentMode.id,
                  name: dataInstalmentMode.name,
                });
              });
            }
            if (element.typesOfPayouts) {
              element.typesOfPayouts.forEach((dataTypesOfPayouts) => {
                this.getTypesOfPayouts.push({
                  id: dataTypesOfPayouts.id,
                  name: dataTypesOfPayouts.name,
                });
              });
            }
            if (element.InsuranceType) {
              element.InsuranceType.forEach((dataInsuranceType) => {
                this.getInsuranceType.push({
                  id: dataInsuranceType.id,
                  name: dataInsuranceType.name,
                });
              });
            }
            if (element.FamilyMember) {
              element.FamilyMember.forEach((dataFamily) => {
                this.nominee.push(dataFamily.name);
                if (dataFamily.id == 0) {
                  this.account_owner.push({ id: "0", name: dataFamily.name });
                } else {
                  this.account_owner.push({
                    id: dataFamily.id,
                    name: dataFamily.name,
                  });
                }
                this.insured_person.push({
                  id: dataFamily.id,
                  name: dataFamily.name,
                });
              });
            }
          });

          this.$store.getters.getEditInsuranceForm.data.form_attributes.fields.forEach(
            (filed_detail) => {
              if (filed_detail.name == "policy_type") {
                if (
                  filed_detail.value == "ULIP - Investment" ||
                  filed_detail.value == "ULIP - Health" ||
                  filed_detail.value == "ULIP - Gratuity" ||
                  filed_detail.value == "ULIP - Pension" ||
                  filed_detail.value == "ULIP - Annuity"
                ) {
                  this.isShow = false;
                  this.isLable = "Fund Value";
                  setTimeout(() => {
                    document.getElementById(
                      "surrender_value_as_on1"
                    ).style.display = "none";
                    document.getElementById("surrender_value1").style.display =
                      "none";
                  }, 50);
                }
              } else if (filed_detail.name == "number_of_regular_payouts") {
                this.number_of_regular_payouts = filed_detail.value.length;
                this.setRegularAmount = filed_detail.value
                  ? filed_detail.value
                  : [];
                this.regular_dialog = true;
              } else if (filed_detail.name == "number_of_money_back_payouts") {
                this.number_of_money_back_payouts = filed_detail.value.length;
                this.payout_details = filed_detail.value
                  ? filed_detail.value
                  : [];
              } else if (filed_detail.name == "instalment_mode") {
                this.instalment_mode = filed_detail.value;
              } else if (filed_detail.name == "premium_due_date") {
                this.premiumDuedate = filed_detail.value;
                // For string value 

                // this.premiumDue = this.premiumDuedate.includes("-");
                // if (this.premiumDue == true) {
                //   this.explode = this.premiumDuedate.split("-");
                //   this.month = this.explode[0];
                //   this.day = this.explode[1];
                // } else {
                //   this.day = filed_detail.value;
                // }

                // For Array value 
                for(let i=0; i<this.premiumDuedate.length; i++){
                  this.premiumDue = this.premiumDuedate[i].includes(" ");
                  // console.log(this.premiumDue);
                  if (this.premiumDue == true) {
                    this.explode = this.premiumDuedate[i].split(" ");
                    console.log(this.explode,"%%%%%%%%%")
                    this.day = this.explode[0];
                    this.month = this.explode[1];
                  }
                  else {
                    this.day = filed_detail.value;
                  }
                }
              }
            }
          );
          this.$loading(false);
          this.changeDateEvent();
        })
        .catch(function (error) {
          console.log(error);
          this.$loading(false);
        });
    },
  },
};
</script>
